import { TRootState } from 'Redux/Reducers';

export const getInsuranceFormData = (state: TRootState) => state.insuranceCooperation.form?.user || null;
